import { ApiResponse } from '@/types';
import { USER_MANAGEMENT_API_ENDPOINTS } from '@/constants';

import api from '@/services/api';

import { IUserCreation } from '@/features/user-management/user-management-creation/interfaces';

export const UserCreationService = {
  CreateUser: async (payload: IUserCreation): Promise<ApiResponse<IUserCreation>> => {
    const response = await api.post(USER_MANAGEMENT_API_ENDPOINTS.USER_CREATION, payload, {
      skipErrorAlert: true,
    });
    return response.data;
  },
};
